import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, Home, Briefcase, FileText, DollarSign, Calendar, Download, Search } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const opportunities = [{
  id: 1,
  type: 'Tender',
  title: 'Supply and Delivery of 100 Agricultural Tractors and Implements',
  reference: 'MAAIF/SUPLS/23-24/00124',
  deadline: '2024-06-15',
  department: 'Agricultural Engineering',
  status: 'Open'
}, {
  id: 2,
  type: 'Tender',
  title: 'Construction of Valley Dams in Karamoja Sub-region',
  reference: 'MAAIF/WRKS/23-24/00089',
  deadline: '2024-06-30',
  department: 'Water for Agricultural Production',
  status: 'Open'
}, {
  id: 3,
  type: 'Job',
  title: 'Senior Agricultural Extension Officer',
  reference: 'HRM/MAAIF/2024/05',
  deadline: '2024-05-28',
  department: 'Extension Services',
  status: 'Open'
}, {
  id: 4,
  type: 'Job',
  title: 'Fisheries Inspector',
  reference: 'HRM/MAAIF/2024/08',
  deadline: '2024-05-28',
  department: 'Fisheries Resources',
  status: 'Open'
}, {
  id: 5,
  type: 'Grant',
  title: 'Agri-Business Matching Grant Facility - Cohort 3',
  reference: 'ACDP/GRANTS/2024/C3',
  deadline: '2024-07-15',
  department: 'Agriculture Cluster Development Project',
  status: 'Open'
}, {
  id: 6,
  type: 'Grant',
  title: 'Youth in Agriculture Innovation Fund',
  reference: 'MAAIF/YIF/2024',
  deadline: '2024-08-01',
  department: 'Planning & Development',
  status: 'Open'
}, {
  id: 7,
  type: 'Tender',
  title: 'Consultancy Services for Baseline Survey on Coffee Production',
  reference: 'MAAIF/SRVCS/23-24/00210',
  deadline: '2024-05-20',
  department: 'Crop Resources',
  status: 'Closing Soon'
}];
export function OpportunitiesPage() {
  const [activeTab, setActiveTab] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const tabs = [{
    id: 'All',
    icon: null
  }, {
    id: 'Tender',
    icon: FileText
  }, {
    id: 'Job',
    icon: Briefcase
  }, {
    id: 'Grant',
    icon: DollarSign
  }];
  const filteredOpportunities = opportunities.filter(opp => {
    const matchesTab = activeTab === 'All' || opp.type === activeTab;
    const matchesSearch = opp.title.toLowerCase().includes(searchQuery.toLowerCase()) || opp.reference.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesTab && matchesSearch;
  });
  return <>
      <Header data-id="element-1244" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-1245">
        {/* Hero Section */}
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-1246">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/sJsiYp5cUGc7RSDnnMVtNE/fdhjkl_(10).jpg")'
        }} data-id="element-1247"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-1248"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-1249">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-1250">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-1251">
                <Home className="w-4 h-4 mr-1" data-id="element-1252" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1253" />
              <span data-id="element-1254">Resources</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1255" />
              <span className="text-white font-medium" data-id="element-1256">Opportunities</span>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1257">
              Opportunities
            </h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed mb-8" data-id="element-1258">
              Explore current tenders, job vacancies, and funding opportunities
              available at the Ministry of Agriculture, Animal Industry and
              Fisheries.
            </p>

            <div className="max-w-2xl relative" data-id="element-1259">
              <input type="text" placeholder="Search by title or reference number..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-4 rounded-lg text-uganda-black focus:outline-none focus:ring-2 focus:ring-uganda-yellow shadow-lg" data-id="element-1260" />
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-6 h-6" data-id="element-1261" />
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12" data-id="element-1262">
          {/* Tabs */}
          <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200 pb-4" data-id="element-1263">
            {tabs.map(tab => {
            const Icon = tab.icon;
            return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-colors ${activeTab === tab.id ? 'bg-uganda-green text-white' : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'}`} data-id="element-1264">
                  {Icon && <Icon className="w-4 h-4" data-id="element-1265" />}
                  {tab.id === 'All' ? 'All Opportunities' : `${tab.id}s`}
                </button>;
          })}
          </div>

          {/* List */}
          <div className="space-y-4" data-id="element-1266">
            {filteredOpportunities.length > 0 ? filteredOpportunities.map((opp, index) => <motion.div key={opp.id} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 flex flex-col md:flex-row md:items-center justify-between gap-6 hover:shadow-md transition-shadow" data-id="element-1267">
                  <div className="flex-1" data-id="element-1268">
                    <div className="flex items-center gap-3 mb-2" data-id="element-1269">
                      <span className={`text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full ${opp.type === 'Tender' ? 'bg-blue-100 text-blue-800' : opp.type === 'Job' ? 'bg-purple-100 text-purple-800' : 'bg-green-100 text-green-800'}`} data-id="element-1270">
                        {opp.type}
                      </span>
                      <span className={`text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full ${opp.status === 'Open' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-1271">
                        {opp.status}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-uganda-black mb-2" data-id="element-1272">
                      {opp.title}
                    </h3>
                    <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500" data-id="element-1273">
                      <span className="font-medium" data-id="element-1274">Ref: {opp.reference}</span>
                      <span className="hidden md:inline text-gray-300" data-id="element-1275">|</span>
                      <span data-id="element-1276">Dept: {opp.department}</span>
                    </div>
                  </div>

                  <div className="flex flex-col md:items-end gap-4 md:w-48 flex-shrink-0 border-t md:border-t-0 md:border-l border-gray-100 pt-4 md:pt-0 md:pl-6" data-id="element-1277">
                    <div className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-1278">
                      <Calendar className="w-4 h-4 text-uganda-red" data-id="element-1279" />
                      Deadline: {opp.deadline}
                    </div>
                    <button className="w-full md:w-auto flex items-center justify-center gap-2 bg-white border border-uganda-green text-uganda-green hover:bg-uganda-green hover:text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors" data-id="element-1280">
                      <Download className="w-4 h-4" data-id="element-1281" /> Details
                    </button>
                  </div>
                </motion.div>) : <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center" data-id="element-1282">
                <Briefcase className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-1283" />
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1284">
                  No opportunities found
                </h3>
                <p className="text-gray-500" data-id="element-1285">
                  There are currently no open {activeTab.toLowerCase()}s
                  matching your search.
                </p>
              </div>}
          </div>
        </div>
      </main>
      <Footer data-id="element-1286" />
    </>;
}